/**
 * CR-7363: the order's ERP remarks as a PO Headers column — customer side only.
 *
 * The remarks are the customer's own notes on the order, so the API never sends
 * them to a supplier; the caller also leaves the column out of the supplier view.
 * Long remarks are cut to one line; the full text shows on hover.
 */

/** The column header. */
export function RemarksHeader() {
  return <th className="text-left py-3 px-3 font-medium">Remarks</th>;
}

interface RemarksCellProps {
  /** The order's ERP remarks, or empty / absent when it has none. */
  remarks?: string | null;
}

/**
 * One order's remarks, truncated to the column width with the full text as a tooltip.
 * @param remarks - the order's ERP remarks
 * @returns the table cell
 */
export function RemarksCell({ remarks }: RemarksCellProps) {
  const text = remarks?.trim();
  return (
    <td className="py-3 px-3 max-w-[16rem]">
      {text ? (
        <span className="block truncate" title={text}>
          {text}
        </span>
      ) : (
        '-'
      )}
    </td>
  );
}
